import { render, staticRenderFns } from "./MobileReset.vue?vue&type=template&id=832f4b9a&scoped=true&"
import script from "./MobileReset.vue?vue&type=script&lang=js&"
export * from "./MobileReset.vue?vue&type=script&lang=js&"
import style0 from "./MobileReset.vue?vue&type=style&index=0&id=832f4b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832f4b9a",
  null
  
)

/* custom blocks */
import block0 from "./MobileReset.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports